import React from 'react';
import ReactDOM from 'react-dom';

import App from './components/AppContainer';

import { Provider } from 'react-redux';
import { messaging } from './firebase';
import * as serviceWorker from './serviceWorker';
import store from './store';
import './index.css';
import config from './config';
import './components/i18n';

if (config.firebase.status) {
  Notification.requestPermission().then(function (permission) {
    if (permission === 'granted') {
      console.log('Notification permission granted.');

      messaging
        .getToken()
        .then(function (currentToken) {
          console.log('Notification currentToken.', currentToken);
          if (currentToken) {
            localStorage.setItem('fcm_token', currentToken);
            // subscribeFCM(currentToken);
            // updateUIForPushEnabled(currentToken);
          } else {
            // Show permission request.
            console.log('No Instance ID token available. Request permission to generate one.');
            // Show permission UI.
            // updateUIForPushPermissionRequired();
            // setTokenSentToServer(false);
          }
        })
        .catch(function (err) {
          console.log('An error occurred while retrieving token. ', err);
          // showToken('Error retrieving Instance ID token. ', err);
          // setTokenSentToServer(false);
        });
    } else {
      console.log('Unable to get permission to notify.');
    }
  });
}

// async function subscribeFCM(token,topic) {
//   console.log('subscribeFCM', token);
//   try {
//     const res = await rp.post(`${config.api.url}/api/fcm/subscribe`, {
//       body: {
//         topic,
//         token,
//       },
//       resolveWithFullResponse: true,
//       json: true,
//     }).auth(null, null, true, 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJhZG1pbiIsImlhdCI6MTU2ODg3OTY5OCwiZXhwIjoxNjAwNDE1Njk4fQ.aBE_VTDIGRs30yayz8blxXcG7M4lia7xczKFlYDTM9w');
//     console.log('subscribeFCM return :',res);
//   } catch (err) {
//     console.log('subscribeFCM err', err);
//   }
// }

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById('root'),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
